import * as types from '@/store/mutationTypes';
import {DefaultPagination, Pagination} from '@/utils/pagination';
import pageOptionsService from '@/http/services/pageOptionsService';
import FilterReceiptsModal from '@/components/modals/FilterReceiptsModal.vue';

export const actions = {
    configPagination: ({ commit }, config) => {
        commit(types.SET_PAGINATION,
            Pagination.createPagination({
                pageSize: config.pageSize,
                totalPages: config.totalPages,
                pageNumber: config.pageNumber,
                totalElements: config.totalElements,
                callback: config.callback,
                numberOfElements: config.numberOfElements
            })
        );
    },

    openNextPage: ({ dispatch, getters }, shouldScrollTop = true) => {
        dispatch('openPage', { pageNumber: getters.pagination.pageNumber + 1, shouldScrollTop });
    },

    openPreviousPage: ({ dispatch, getters }, shouldScrollTop = true) => {
        dispatch('openPage', { pageNumber: getters.pagination.pageNumber - 1, shouldScrollTop });
    },

    openPage: ({ commit, dispatch }, payload) => {
        const pageNumber = (payload && payload.pageNumber !== undefined) ? payload.pageNumber : payload;
        const shouldScrollTop = payload.shouldScrollTop;
        if (Number.isInteger(pageNumber)) {
            commit(types.GO_TO_PAGE, pageNumber);
            dispatch('makeRequest', shouldScrollTop);
        }
    },

    changePageSize: ({ commit, dispatch }, pageSize) => {
        commit(types.SET_PAGE_SIZE, pageSize);
        dispatch('openPage', DefaultPagination.firstPage);
    },

    makeRequest: ({ getters }, shouldScrollTop = true) => {
        try {
            getters.pagination.callback();
            if (shouldScrollTop) {
                window.scrollTo(0, 0);
            }
        } catch (e) {
            throw e;
        }
    },

    getLocations: async ({ commit }) => {
        const locations = await pageOptionsService.getLocations();

        commit(types.SET_LOCATIONS, locations);
    },

    openFilterModal: ({ commit, dispatch }, routeName) => {
        // depends on the route name we can open different filter modals

        switch (routeName) {
            case 'RECEIPTS':
                dispatch('openModal', {
                    modal: FilterReceiptsModal,
                });
                break;
        }
        
    },

    updateSearch: ({ commit, dispatch }, payload) => {
        commit(types.UPDATE_SEARCH, payload);
        commit(types.SET_PAGE_NUMBER, DefaultPagination.pageNumber);
        dispatch('makeRequest');
    },

    updateSorting: ({ commit, dispatch }, payload) => {
        commit(types.UPDATE_SORTING, payload);
        commit(types.SET_PAGE_NUMBER, DefaultPagination.pageNumber);
        dispatch('makeRequest');
    },

    updateFilterDay: ({ commit, dispatch }, payload) => {
        commit(types.UPDATE_FILTERS, payload);
        commit(types.SET_PAGE_NUMBER, DefaultPagination.pageNumber);
        dispatch('makeRequest');
    },

    updateFilterDropdown: ({ commit, dispatch }, payload) => {
        commit(types.UPDATE_FILTERS_DROPDOWN, payload);
        commit(types.SET_PAGE_NUMBER, DefaultPagination.pageNumber);
        dispatch('makeRequest');
    },

    resetFilters: ({ commit, dispatch }) => {
        commit(types.RESET_FILTERS);
        commit(types.SET_PAGE_NUMBER, DefaultPagination.pageNumber);
        dispatch('makeRequest');
    },

    resetPageOptions: ({ commit }) => {
        commit(types.UPDATE_SEARCH, null);
        commit(types.UPDATE_SORTING, 'DESC');
        commit(types.RESET_FILTERS);
        commit(types.REMOVE_PAGINATION);
    },

    setModalFilters: ({ commit }, filters) => {
        commit(types.SET_MODAL_FILTERS, filters);
    },
    resetModalFilters: ({ commit }) => {
        commit(types.RESET_MODAL_FILTERS);
    },
};


// WEBPACK FOOTER //
// ./src/store/modules/pageOptions/actions.js